import React from "react";
import { Navigate } from "react-router-dom";
import { API_BASE_URL } from "../const/config";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const token = localStorage.getItem(`${API_BASE_URL}_token`);
  return token ? <>{children}</> : <Navigate to="/login" />;
};

export default ProtectedRoute;
